import { Link } from 'react-router-dom';

export default function Solutions() {
  const solutions = [
    {
      icon: 'ri-funds-box-line',
      title: 'Cash Flow Stabilization',
      description:
        'Our cash flow forecast model gives distressed businesses the visibility and control they need to survive and recover.',
      link: 'Learn More',
      href: '/services',
    },
    {
      icon: 'ri-refresh-line',
      title: 'Structured Turnarounds',
      description:
        'Cost-effective turnarounds built on a highly structured approach with a fixed fee and fixed timeline, so you always know what to expect.',
      link: 'Explore',
      href: '/services',
    },
    {
      icon: 'ri-shake-hands-line',
      title: 'Creditor & Lender Solutions',
      description:
        'We represent you in negotiations with lenders and creditors to determine the best financial path forward — protecting your business and your relationships.',
      link: 'Get Started',
      href: '/services',
    },
  ];

  return (
    <section className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 mb-16">
          <div>
            <h2 className="text-5xl lg:text-6xl font-serif font-bold text-slate-900 leading-tight">
              The Only Solution for Distressed Companies
            </h2>
          </div>
          <div className="flex items-center">
            <p className="text-gray-600 text-lg leading-relaxed">
              We are passionate about helping businesses maximize opportunities
              and solve financial challenges at an affordable cost and in an
              empathetic manner. Our goal is to educate you on cash flow and
              operational best practices so you can grow, meet your obligations
              to creditors, and thrive.
            </p>
          </div>
        </div>

        <div className="grid lg:grid-cols-3 gap-8">
          {solutions.map((solution, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-8 border-2 border-gray-200 hover:border-teal-500 transition-all hover:shadow-xl flex flex-col"
            >
              <div className="w-16 h-16 bg-teal-500 rounded-2xl flex items-center justify-center mb-6">
                <i className={`${solution.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-2xl font-bold text-slate-900 mb-4">
                {solution.title}
              </h3>
              <p className="text-gray-600 leading-relaxed mb-6 flex-grow">
                {solution.description}
              </p>
              <Link
                to={solution.href}
                className="inline-flex items-center gap-2 text-teal-600 font-semibold hover:gap-3 transition-all cursor-pointer mt-auto"
              >
                {solution.link}
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}